import * as React from 'react'
import { Formik } from 'formik'
import { SideDrawer } from '@sales-center/components'
import { AddImportUtilityForm } from './AddImportUtilityForm/AddImportUtilityForm'
import { useData } from './hooks/useData'
import { useHandlers } from './hooks/useHandlers'
import { ImportUtilityModel } from './typings'

type Props = {
  onClose: () => void
  onSave: (importDefaultValues: ImportUtilityModel) => void
  open: boolean
}

export default function AddImportUtilityDrawer(props: Props) {
  const { onClose, open, onSave } = props

  const { validate, initialValues } = useData()

  const { onSubmit } = useHandlers({ onClose, onSave })

  return (
    <SideDrawer
      tidalThemeActive={true}
      title={'Import'}
      open={open}
      onClose={onClose}
      width={495}
      titleVariant="h5"
    >
      <Formik
        onSubmit={onSubmit}
        validate={validate}
        initialValues={initialValues}
      >
        <AddImportUtilityForm onClose={onClose} />
      </Formik>
    </SideDrawer>
  )
}
